module.exports = __webpack_public_path__ + "img/img-AtlasCOVID19-portada.11f14d6d.jpg";